import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { v4 as uuidv4 } from "uuid";
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: "root",
})
export class DocumentsService {
  constructor(private http: HttpClient) {}



  /*
  El documento container es un contenedor de documentos. Se puede crear un documento container con un tipo de contenedor y un id de contenedor.
  Estos son los campos mínimos para crear un documento container, pero se podrán enviar tantos campos como se requieran.
  */

  //Crea un nuevo documento en una empresa
  createDocumentContainer(
      businessId: string,
      documentContainerId: any,
      containerType: string,
      event: any,
      body: any
  ): Observable<any> {
    const headers = {
      "Content-Type": "application/json",
      "x-business-id": businessId,
    };

    if (!body.documentContainerId) {
      body.documentContainerId = documentContainerId || uuidv4();
    }

    if (!body.containerType) {
      body.containerType = containerType;
    }

    const ES = {
      pattern: body.containerType,
      docId: "documentContainerId",
    };

    body.elasticsearch = ES;

    // add date to event
    if (event !== null) {
      event.date = new Date();
      body.event = event;
    };


    return this.http.post<any>(`${environment.BASE_URL}/document`, body, {
      headers,
    });
  }

  // Actualiza un nuevo documento en una empresa
  updateDocumentContainer(
      businessId: string,
      documentContainerId: string,
      containerType: string,
      event: any,
      body: any
  ): Observable<any> {
    const headers = {
      "Content-Type": "application/json",
      "x-business-id": businessId,
    };

    if (!body.documentContainerId) {
      body.documentContainerId = documentContainerId || uuidv4();
    }

    if (!body.containerType) {
      body.containerType = containerType;
    }

    const ES = {
      pattern: body.containerType,
      docId: "documentContainerId",
    };

    body.elasticsearch = ES;

    if (event !== null) {
      event.date = new Date();
      body.event = event;
    };



    return this.http.put<any>(`${environment.BASE_URL}/document`, body, {
      headers,
    });
  }

  //Trae todos los contenedores de una empresa
  getContainersByBusinessId(businessId: string): Observable<any> {
    const headers = {
      "Content-Type": "application/json",
      "x-business-id": businessId,
    };
    return this.http.get(`${environment.BASE_URL}/document`, { headers });
  }

  //Obtiene un contenedor de documentos
  getDocumentContainer(
      businessId: string,
      documentContainerId: string
  ): Observable<any> {
    const headers = {
      "Content-Type": "application/json",
      "x-business-id": businessId,
    };
    let params = new HttpParams();
    params = params.append("documentContainerId", documentContainerId);
    return this.http.get(`${environment.BASE_URL}/document`, {
      headers,
      params,
    });
  }

  //Obtiene contenedores por tipo
  getDocumentContainerByType(
      businessId: string,
      containerType: string
  ): Observable<any> {
    const headers = {
      "Content-Type": "application/json",
      "x-business-id": businessId,
    };
    let params = new HttpParams();
    params = params.append("type", containerType);
    return this.http.get(`${environment.BASE_URL}/document`, {
      headers,
      params,
    });
  }

  /* El documento es un archivo que se guarda en un contenedor. Se puede crear un documento con un tipo de documento y un id de documento.
  Estos son los campos mínimos para crear un documento, pero se podrán enviar tantos campos como se requieran.*/

  //Crea un documento en un contenedor de documentos
  createDocumentInContainer(
      businessId: string,
      documentContainerId: string,
      documentId: any,
      documentType: string,
      event: any,
      body: any
  ): Observable<any> {
    const headers = {
      "Content-Type": "application/json",
      "x-business-id": businessId,
    };
    if (!body.documentId) {
      body.documentId = documentId || uuidv4();
    }

    if (!body.documentContainerId) {
      body.documentContainerId = documentContainerId;
    }

    if (!body.documentType) {
      body.documentType = documentType;
    }

    const ES = {
      pattern: body.documentType,
      docId: "documentId",
    };

    body.elasticsearch = ES;

    if (event !== null) {
      event.date = new Date();
      body.event = event;
    };


    return this.http.post<any>(`${environment.BASE_URL}/document/file`, body, {
      headers,
    });
  }

  // Actualiza un documento en un contenedor de documentos
  updateDocumentInContainer(
      businessId: string,
      documentContainerId: string,
      documentId: any,
      documentType: string,
      event: any,
      body: any
  ): Observable<any> {
    const headers = {
      "Content-Type": "application/json",
      "x-business-id": businessId,
    };
    if (!body.documentId) {
      body.documentId = documentId || uuidv4();
    }

    if (!body.documentContainerId) {
      body.documentContainerId = documentContainerId;
    }

    if (!body.documentType) {
      body.documentType = documentType;
    }

    const ES = {
      pattern: body.documentType,
      docId: "documentId",
    };

    body.elasticsearch = ES;

    if (!body.event) {
      body.event = event? event : null;
      if (body.event !== null) {
        event.date = new Date();
      }
    }

    return this.http.put<any>(`${environment.BASE_URL}/document/file`, body, {
      headers,
    });
  }

  //Trae todos los documentos de un contenedor
  getDocumentsByContainerId(
      businessId: string,
      documentContainerId: string
  ): Observable<any> {
    const headers = {
      "Content-Type": "application/json",
      "x-business-id": businessId,
    };
    let params = new HttpParams();
    params = params.append("documentContainerId", documentContainerId);
    return this.http.get(`${environment.BASE_URL}/document/file`, {
      headers,
      params,
    });
  }

  //Obtener un documento por su id
  getDocumentById(
      businessId: string,
      documentContainerId: string,
      documentId: string
  ): Observable<any> {
    const headers = {
      "Content-Type": "application/json",
      "x-business-id": businessId,
    };
    let params = new HttpParams();
    params = params.append("documentContainerId", documentContainerId);
    params = params.append("documentId", documentId);
    return this.http.get(`${environment.BASE_URL}/document/file`, {
      headers,
      params,
    });
  }

  getDocumentByIdAux(
      businessId: string,
      documentId: string
  ): Observable<any> {
    const headers = {
      "Content-Type": "application/json",
      "x-business-id": businessId,
    };

    return this.http.get(`${environment.BASE_URL}/document/file?documentId=${documentId}`, {
      headers
    });
  }

  //Obtener un documento por tipo
  getDocumentsByType(
      businessId: string,
      documentContainerId: string,
      documentType: string
  ): Observable<any> {
    const headers = {
      "Content-Type": "application/json",
      "x-business-id": businessId,
    };
    let params = new HttpParams();
    params = params.append("documentContainerId", documentContainerId);
    params = params.append("type", documentType);
    return this.http.get(`${environment.BASE_URL}/document/file`, {
      headers,
      params,
    });
  }

  /*
  El documento attachment es un archivo que se guarda en un documento. Se puede crear un documento attachment con un tipo de attachment y un id de attachment.
  Estos son los campos mínimos para crear un documento attachment, pero se podrán enviar tantos campos como se requieran.
  */

  //Crea un document file attachment
  createDocumentAttachment(
      businessId: string,
      documentId: string,
      attachmentId: any,
      attachmentType: string,
      event: any,
      body: any
  ): Observable<any> {
    const headers = {
      "Content-Type": "application/json",
      "x-business-id": businessId,
    };
    if (!body.attachmentId) {
      body.attachmentId = attachmentId || uuidv4();
    }

    if (!body.documentId) {
      body.documentId = documentId;
    }

    if (!body.attachmentType) {
      body.attachmentType = attachmentType;
    }

    const ES = {
      pattern: body.attachmentType,
      docId: "attachmentId",
    };

    if (event !== null) {
      event.date = new Date();
      body.event = event;
    };


    body.elasticsearch = ES;

    return this.http.post<any>(
        `${environment.BASE_URL}/document/file/attachment`,
        body,
        { headers }
    );
  }

  updateDocumentAttachment(
      businessId: string,
      documentId: string,
      attachmentId: any,
      attachmentType: string,
      event: any,
      body: any
  ): Observable<any> {
    const headers = {
      "Content-Type": "application/json",
      "x-business-id": businessId,
    };
    if (!body.attachmentId) {
      body.attachmentId = attachmentId || uuidv4();
    }

    if (!body.documentId) {
      body.documentId = documentId;
    }

    if (!body.attachmentType) {
      body.attachmentType = attachmentType;
    }

    const ES = {
      pattern: body.attachmentType,
      docId: "attachmentId",
    };

    body.elasticsearch = ES;

    if (event !== null) {
      event.date = new Date();
      body.event = event
    };



    return this.http.put<any>(
        `${environment.BASE_URL}/document/file/attachment`,
        body,
        { headers }
    );
  }

  // Se podrán consultar por todos los attachments de la empresa, por un documento, por tipo de attachment.
  // Trae todos los attachments de un documento
  getAttachmentsByDocumentId(
      businessId: string,
      documentId: string
  ): Observable<any> {
    const headers = {
      "Content-Type": "application/json",
      "x-business-id": businessId,
    };
    let params = new HttpParams();
    params = params.append("documentId", documentId);
    return this.http.get(`${environment.BASE_URL}/document/file/attachment`, {
      headers,
      params,
    });
  }

  //Obtener un attachment por su id
  getAttachmentById(
      businessId: string,
      documentId: string,
      attachmentId: string
  ): Observable<any> {
    const headers = {
      "Content-Type": "application/json",
      "x-business-id": businessId,
    };
    let params = new HttpParams();
    params = params.append("documentId", documentId);
    params = params.append("attachmentId", attachmentId);
    return this.http.get(`${environment.BASE_URL}/document/file/attachment`, {
      headers,
      params,
    });
  }

  //Obtener un attachment por tipo
  getAttachmentByType(
      businessId: string,
      documentId: string,
      attachmentType: string
  ): Observable<any> {
    const headers = {
      "Content-Type": "application/json",
      "x-business-id": businessId,
    };
    let params = new HttpParams();
    params = params.append("documentId", documentId);
    params = params.append("type", attachmentType);
    return this.http.get(`${environment.BASE_URL}/document/file/attachment`, {
      headers,
      params,
    });
  }

  searchDocument(
      businessId: string,
      pattern: string,
      query: any
  ): Observable<any> {
    const headers = {
      "Content-Type": "application/json",
      "x-business-id": businessId,
    };

    const payload = {
      pattern: pattern,
      query: query,
    };
    return this.http.post(`${environment.BASE_URL}/document/search`, payload, {
      headers,
    });
  }

  setSequence(
      businessId: string,
      criteria: any,
  ): Observable<any> {
    const headers = {
      "Content-Type": "application/json",
      "x-business-id": businessId,
    };

    return this.http.post(`${environment.BASE_URL}/document/sequence`, criteria, {
      headers,
    });
  }

  //Funcion que recibe un objeto con los filtros y devuelve un arreglo de objetos con los filtros que tienen valor
  getFiltersArray(filters:any){
    let filtersArray:any[] = [];
    for (const key in filters) {
      //validar que tenga un valor
      if (filters[key]) {
        //validar si es string o number
        switch (typeof filters[key]) {
          case "string":
            const newKey= key+'.keyword';
            filtersArray.push({
              "match_phrase": {
                [newKey]: filters[key]
              }
            });
            break;
          case "number":
            //TODO: validar si vale la pena separar el case para darle un formato diferente
            const newKeyNum= key+'.keyword';
            filtersArray.push({
              "match_phrase": {
                [newKeyNum]: filters[key]
              }
            });
            break;
          case "boolean":
            console.log('boolean');
            console.log(filters[key]);

            filtersArray.push({
              "match_phrase": {
                [key]: filters[key]
              }
            });
            break;
          case "object":
            filtersArray.push({
              key: key,
              value: filters[key],
            });
            break;
          default:
            const newKeyDef= key+'.keyword';
            filtersArray.push({
              "match_phrase": {
                [newKeyDef]: filters[key]
              }
            });
            break;
        }
      }
    }
    return filtersArray;
  }

}
